// frontend/src/Root.jsx
import { useState } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import { useMediaQuery, useTheme } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { Outlet, useLocation } from 'react-router-dom';
import { MemoryRouter } from 'react-router-dom';
import { StaticRouter } from 'react-router-dom/server';
import 'react-toastify/dist/ReactToastify.css';
import SearchInput from './components/SearchInput';
import DrawerPanel from './components/DrawerPanel';

const drawerWidth = 240;


function Router(props) {
  const { children } = props;
  if (typeof window === 'undefined') {
    return <StaticRouter location='/'>{children}</StaticRouter>;
  }

  return <MemoryRouter>{children}</MemoryRouter>;
}

Router.propTypes = {
  children: PropTypes.node,
};

function Root(props) {
  const location = useLocation();

  // 🤖 ДОБАВЛЯЕМ ПРОВЕРКУ: Является ли текущий роут мини-приложением бота?
  const isBotApp = location.pathname.startsWith('/bot-app');

  const theme = useTheme();
  const { window, toggleColorMode } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
  const matchDownSm = useMediaQuery(theme.breakpoints.down('sm'));


  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleColorModeChange = () => {
    toggleColorMode();
  };

 
  const container =
    window !== undefined ? () => window().document.body : undefined;

  // 🤖 ЕСЛИ ЭТО БОТ: Отдаем "голый" контент без шапок, меню и лишних отступов
  if (isBotApp) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          bgcolor: 'background.default',
          color: 'text.primary',
          overflowX: 'hidden',
        }}
      >
        <CssBaseline />
        <Outlet />
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar
          position='fixed'
          sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
          }}
        >
          <Toolbar>
            <IconButton
              color='inherit'
              aria-label='open drawer'
              edge='start'
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                alignItems: 'right',
                justifyContent: 'right',
              }}
            >
              {location?.pathname.includes('/crm/') && <SearchInput />}
              <IconButton
                sx={{ ml: 1 }}
                onClick={handleColorModeChange}
                color='inherit'
              >
                {theme.palette.mode === 'dark' ? (
                  <Brightness7Icon />
                ) : (
                  <Brightness4Icon />
                )}
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
        <Box
          component='nav'
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
          aria-label='mailbox folders'
        >
          <Drawer
            container={container}
            //variant='temporary'
            variant={matchUpMd ? 'persistent' : 'temporary'}
            anchor='left'
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: 'block', sm: 'none' },
              '& .MuiDrawer-paper': {
                boxSizing: 'border-box',
                width: drawerWidth,
                background: theme.palette.background.default,
                color: theme.palette.text.primary,
                borderRight: 'none',
                [theme.breakpoints.up('md')]: {
                  top: '88px',
                },
              },
            }}
          >
            <DrawerPanel setMobileOpen={setMobileOpen} />
          </Drawer>
          <Drawer
            variant='permanent'
            sx={{
              display: { xs: 'none', sm: 'block' },
              '& .MuiDrawer-paper': {
                boxSizing: 'border-box',
                width: drawerWidth,
              },
            }}
            open
          >
            <DrawerPanel setMobileOpen={setMobileOpen} />
          </Drawer>
        </Box>
        <Box
          component='main'
          sx={{
            flexGrow: 1,
            p: matchDownSm ? 1 : 3,
            pt: 9,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </>
  );
}

export default Root;
